import { render, staticRenderFns } from "./vehicleDelivery.vue?vue&type=template&id=225e743c&scoped=true"
import script from "./vehicleDelivery.vue?vue&type=script&lang=js"
export * from "./vehicleDelivery.vue?vue&type=script&lang=js"
import style0 from "./vehicleDelivery.vue?vue&type=style&index=0&id=225e743c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "225e743c",
  null
  
)

export default component.exports